import React from 'react'
import Navbar from '../../navbar/Navbar'
import Footer from '../Home/Sections/Footer'
import Donateinfo from './Donateinfo'

const Contact = () => {
  return (
    <main>
      <Navbar/>
      <Donateinfo />
      <Footer/>
    </main>
  )
}

export default Contact
